import React from 'react';
import { CTAButton } from '../ui/CTAButton';
export function FeaturesSection() {
  const features = [{
    num: '01',
    title: '222 fórmulas organizadas por categoría',
    desc: 'No una lista desordenada. Un banco estructurado de fórmulas clasificadas por tipo de producto: facial, corporal, capilar, labial y más. Cada receta con proporciones exactas que podés reproducir.',
    benefit: 'Con esto, terminás para siempre con la improvisación. Sabés exactamente qué cantidad de cada ingrediente usar — cada vez.',
    quote: '"Por primera vez, mi crema quedó igual dos veces seguidas."'
  }, {
    num: '02',
    title: 'Criterios de seguridad y conservación integrados',
    desc: 'Cada fórmula incluye los datos técnicos que ninguna receta gratuita menciona: conservante adecuado, rango de pH, tiempo de vida útil y señales de deterioro.',
    benefit: 'Podés aplicar tus cosméticos con tranquilidad. Sabés que están bien formulados — y sabés cuándo ya no sirven.',
    quote: '"Dejé de tenerle miedo a los conservantes. Ahora sé exactamente cuál usar y en qué porcentaje."'
  }, {
    num: '03',
    title: 'Guía de troubleshooting: por qué falla y cómo corregirlo',
    desc: 'La sección que más valoran quienes ya llevan tiempo intentándolo. Explica por qué se cortan las emulsiones, por qué no espesan los productos y qué hacer en cada caso.',
    benefit: 'Cada error que tuviste antes tiene una explicación — y una solución. Tus fallos pasados se convierten en aprendizaje real.',
    quote: '"Entendí por qué siempre se me cortaba la emulsión. No era yo — era que faltaba temperatura."'
  }, {
    num: '04',
    title: 'Ingredientes con sustituciones por país',
    desc: 'Resuelve uno de los dolores más prácticos: hay ingredientes que en Argentina no se consiguen, en México sí pero con otro nombre, en España con diferente concentración. Este listado incluye alternativas reales para España, México, Argentina, Chile y Colombia.',
    benefit: 'No importa desde dónde formulés. Las recetas funcionan con lo que tenés disponible.',
    quote: '"Por fin, recetas que puedo hacer con ingredientes que consigo en mi ciudad."'
  }, {
    num: '05',
    title: 'Formato PDF optimizado para móvil',
    desc: 'Diseñado para usarse desde el celular mientras formulás. Sin tener que pinchar y reducir pantalla. Sin imprimir. Sin depender de estar frente a una computadora.',
    benefit: 'Lo abrís en el teléfono, seguís la fórmula, y trabajás. Así de simple.',
    quote: '"Lo uso directamente desde el celular mientras preparo. No necesito nada más."'
  }];
  return <section className="py-10 md:py-16 px-4 bg-sage" data-id="element-30">
      <div className="max-w-6xl mx-auto" data-id="element-31">
        <div className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-32">
          {features.map((feature, index) => <div key={index} className={`p-3 md:p-6 border-l-[3px] border-accent ${index % 2 === 0 ? 'bg-cream' : 'bg-white'} shadow-sm`} data-id="element-33">
              <span className="text-[24px] md:text-[36px] font-serif font-bold text-accent-light leading-none block mb-2 md:mb-3" data-id="element-34">
                {feature.num}
              </span>
              <h3 className="text-[14px] md:text-[20px] font-bold text-primary-dark mb-1 md:mb-2 leading-tight" data-id="element-35">
                {feature.title}
              </h3>
              <p className="text-[12px] md:text-[16px] text-ink leading-[1.4] md:leading-[1.5] mb-2 md:mb-3" data-id="element-36">
                {feature.desc}
              </p>
              <p className="text-[12px] md:text-[16px] text-primary leading-[1.4] md:leading-[1.5] mb-3 md:mb-4 font-semibold" data-id="element-37">
                {feature.benefit}
              </p>
              <p className="text-[11px] md:text-[15px] italic text-muted border-t border-divider pt-2 md:pt-3" data-id="element-38">
                {feature.quote}
              </p>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-39">
          <CTAButton className="w-full md:max-w-md mx-auto" data-id="element-40">
            → ACCEDER AL SISTEMA AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}